// The interface themes both front ends offer. How each one applies them, and where it keeps the choice, stays its own.
export const THEMES = ['system', 'light', 'dark', 'ocean', 'sunset'] as const;
export type ThemeId = (typeof THEMES)[number];
export type ResolvedTheme = Exclude<ThemeId, 'system'>;

/** Background of each theme, for the browser's `theme-color` (keep in sync with both style sheets). */
export const THEME_BG: Record<ResolvedTheme, string> = { light: '#f3f5f8', dark: '#090b10', ocean: '#06101a', sunset: '#110a10' };

export const isTheme = (v: unknown): v is ThemeId => typeof v === 'string' && (THEMES as readonly string[]).includes(v);

/** "System" follows the OS: light or dark, the default look. */
export const resolveTheme = (id: ThemeId, prefersLight: boolean): ResolvedTheme => (id === 'system' ? (prefersLight ? 'light' : 'dark') : id);

/** The saved choice, or "system" when there is none or the storage is unavailable. */
export function savedTheme(key: string, store: Pick<Storage, 'getItem'> | null): ThemeId {
  try {
    const v = store?.getItem(key);
    if (isTheme(v)) return v;
  } catch {
    /* storage unavailable */
  }
  return 'system';
}
